import { ProductKey } from '@atlassiansox/bxpkit-core';
import { ProductPayloadType } from '../../layouts/devops-screen/types';

type LoggedInFormDataConsentType = {
  readonly marketingConsent?: boolean;
};

type LoggedInFormDataProductType = {
  readonly cloudName?: string;
  readonly productsNew?: ProductPayloadType[];
  readonly productsExisting?: ProductKey[];
  readonly bbWorkspaceName?: string;
};

type SubmitType =
  | undefined
  | 'shouldSubmit'
  | 'submitting'
  | 'success'
  | 'failure';

type LoggedInFormDataSubmitType = {
  readonly submitStatus: SubmitType;
};

type LoggedInFormDataFreeBreachType = {
  readonly isSiteInFreeBreach: boolean;
};

export type LoggedInFormDataType = LoggedInFormDataConsentType &
  LoggedInFormDataProductType &
  LoggedInFormDataSubmitType &
  LoggedInFormDataFreeBreachType;

type LoggedInFormDataActionType = {
  readonly type: string;
  readonly payload?: Partial<LoggedInFormDataType> | LoggedInFormDataType;
};

// Actions
const UPDATE_PRODUCTS = 'logged-in-form-data/UPDATE_PRODUCTS';
const UPDATE_CONSENT = 'logged-in-form-data/UPDATE_CONSENT';
const UPDATE_SUBMIT = 'logged-in-form-data/UPDATE_SUBMIT';
const UPDATE_FREE_BREACH = 'logged-in-form-data/UPDATE_FREE_BREACH';

// Initial State
const initialState: LoggedInFormDataType = {
  cloudName: undefined,
  productsNew: undefined,
  productsExisting: undefined,
  marketingConsent: undefined,
  bbWorkspaceName: undefined,
  isSiteInFreeBreach: false,
  submitStatus: undefined
};

// Reducer
export const loggedInFormDataReducer = (
  state = initialState,
  action: LoggedInFormDataActionType
): LoggedInFormDataType => {
  switch (action.type) {
    case UPDATE_PRODUCTS:
      return Object.assign({}, state, action.payload);
    case UPDATE_CONSENT:
      return {
        ...state,
        marketingConsent: action.payload?.marketingConsent
      };
    case UPDATE_SUBMIT:
      return {
        ...state,
        submitStatus: action.payload?.submitStatus
      };
    case UPDATE_FREE_BREACH:
      return {
        ...state,
        isSiteInFreeBreach: action.payload?.isSiteInFreeBreach || false
      };
    default:
      return state;
  }
};

// Action Creators
export function updateLoggedInFormDataProducts(
  payload: LoggedInFormDataProductType
): LoggedInFormDataActionType {
  return {
    type: UPDATE_PRODUCTS,
    payload
  };
}

export function updateLoggedInFormDataConsent(
  payload: LoggedInFormDataConsentType
): LoggedInFormDataActionType {
  return {
    type: UPDATE_CONSENT,
    payload
  };
}

export function updateLoggedInFormDataSubmitStatus(
  submitStatus: SubmitType
): LoggedInFormDataActionType {
  return {
    type: UPDATE_SUBMIT,
    payload: {
      submitStatus
    }
  };
}

export function updateLoggedInFormDataFreeBreach(
  isSiteInFreeBreach: boolean
): LoggedInFormDataActionType {
  return {
    type: UPDATE_FREE_BREACH,
    payload: {
      isSiteInFreeBreach
    }
  };
}
